<template>
<div class="container pb-4">
    <div class="row">
        <div class="col"><div class="section-heading-md pt-0 pb-3">Return confirmation</div></div>
    </div>

     <div class="card">
    <div class="card-body">
        <div class="text-center alert alert-success py-2 mx-auto" style="width:fit-content;">Your return has been submitted</div>
        <div class="text-center mt-3">Please check your email for confirmation and next steps</div>
        <div class="mt-3 text-center"><a href="/returns" class="btn btn-danger px-3">See returns</a></div>
    </div>
    </div>
    
    </div>
</template>

<script>
export default {

  data() {
    return {

    };
  },

  created() {

  },

  methods: {


  },
};
</script> 
